import Link from "next/link";
import LayoutMaster from "../../components/layout/layout_master";
import Img from "react-cloudimage-responsive";
import { GetServerSideProps } from "next";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";

interface Props {
  infomation: CheckWithPrefixResponse;
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

export default function PromotionFirstDay(_props: Props) {
  return (
    <LayoutMaster
      content_setting={{
        title: "โปรโมชั่น ฝากเงินครั้งแรกรับเลย 1,000 uDiamond",
        description:
          "ฝากเงิน ครั้งแรก ของวัน รับเลย 1,000 uDiamond สามารถ นำ uDiamond ไปเล่น กิจกรรมของเรา เพื่อลุ้นรับเครดิตฟรี ได้ ง่ายๆ เว็บพนันออนไลน์ที่ดีที่สุด",
      }}
      information={_props.infomation}
    >
      <div className="container" style={{ paddingTop: 10 }}>
        <h1 className="center-content">
          <span>ฝากเงินครั้งแรกของวันรับเลย 1,000 uDiamond</span>
        </h1>
        <div className="margin-top-20">
          <Img
            ratio={3 / 1}
            src="promotion-firsttime-deposit-4.png"
            alt="โปรโมชั่นฝากเงิน รับฟรี 1,000 udiamond ทุกวัน"
          ></Img>
        </div>
        <div className="bg-blue border-radius">
          <h2 className="text-center margin-top-20" style={{ paddingTop: 20 }}>
            <span>โปรโมชั่นพิเศษสำหรับสมาชิกทุกท่าน</span>
          </h2>
          <p className="text-center margin-left-10 margin-right-10">
            ฝากเงินครั้งแรกของวันแจกทันที 1,000 uDiamond ท่านสามารถนำ uDiamond
            ไปเล่นกิจกรรมต่างๆภายใน ลุ้นรับเครดิตไปใช้กันแบบฟรีๆ
          </p>
          <p className="bottom-line-yellow"></p>
          <h4 className="margin-left-10">ขั้นตอนการรับรางวัล</h4>
          <ul className="margin-left-10" style={{ paddingBottom: 20 }}>
            <li>
              ฝากเงินกับทางเรา{" "}
              <Link href="/bank">
                <a>
                  <span>คลิก</span>
                </a>
              </Link>{" "}
            </li>
            <li>รับทันที uDiamond จำนวน 1,000 uDiamond</li>
            <li>โปรโมชั่นรีทุก 7.00 น. ของทุกวัน</li>
            <li>
              uDiamond สามารถนำไปแลกเป็นเครดิตได้{" "}
              <Link href="/exchange">
                <a>
                  <span>คลิก</span>
                </a>
              </Link>
            </li>
            <li className="font-red">
              *นโยบายอาจเปลี่ยนแปลงไปตามที่บริษัทเป็นผู้กำหนด
              หากพยายามทุจริตหรือปลอมแปลงใดๆ จะมีกฏลงโทษแบนทันที
            </li>
          </ul>
        </div>
      </div>
    </LayoutMaster>
  );
}
